import { DialogController } from "@lib/titan2-slingo/dist/game/controller/DialogController";
import { HTMLHelp } from "../view/abstract/display/HTMLHelp";
import { GameHTMLHelpProperties } from "../view/abstract/properties/GameHTMLHelpProperties";
/**
 * GameDialogController.ts
 */
export class GameDialogController extends DialogController {
    create() {
        super.create();
        this.createHelp();
    }
    createHelp() {
        this.help = new HTMLHelp(new GameHTMLHelpProperties());
    }
    handleHelpOpen() {
        this.help.open();
    }
}
//# sourceMappingURL=GameDialogController.js.map